module.exports = __webpack_public_path__ + "img/sankaku_58_red.959b3fe3.png";